import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Spinner from './CommonUIComponents/Spinner';
import { Button } from 'antd';
import './App.css';

const PaySuccess = () => {
    const [loading, setLoading] = useState(true);
    const [paymentStatus, setPaymentStatus] = useState(null);
    const [error, setError] = useState(null);
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        const verifyPayment = async () => {
            // 从URL中提取session_id参数
            const urlParams = new URLSearchParams(location.search);
            const sessionId = urlParams.get('session_id');

            if (!sessionId) {
                setError('Missing session ID');
                setLoading(false);
                return;
            }

            try {
                // 获取认证token
                const token = sessionStorage.getItem("ZeitroA");
                
                // 调用后端接口验证支付状态
                const response = await fetch('/api/v1/los/stripe/verifyCheckoutSession', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': "Bearer " + token,
                        'Cache': "no-cache"
                    },
                    body: JSON.stringify({ session_id: sessionId }),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const result = await response.json();
                setPaymentStatus(result);
            } catch (err) {
                console.error('Payment verification error:', err);
                setError('Failed to verify payment status');
            } finally {
                setLoading(false);
            }
        };

        verifyPayment();
    }, [location.search]);

    const handleGoHome = () => {
        history.push('/app/welcome');
    };

    if (loading) {
        return (
            <div className="pay-success-page" style={{ padding: '20px', textAlign: 'center' }}>
                <Spinner />
                <p>Verifying payment status...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="pay-success-page" style={{ padding: '20px', textAlign: 'center' }}>
                <h2>Payment Verification Error</h2>
                <p>{error}</p>
                <Button type="primary" onClick={handleGoHome}>
                    Go to Home
                </Button>
            </div>
        );
    }

    return (
        <div className="pay-success-page" style={{ padding: '20px', textAlign: 'center' }}>
            <h2>Payment Successful!</h2>
            {paymentStatus && (
                <div>
                    <p>Thank you for your payment.</p>
                    <p>Payment ID: {paymentStatus.id}</p>
                    <p>Status: {paymentStatus.status}</p>
                    <p>Amount: ${(paymentStatus.amount_total / 100).toFixed(2)}</p>
                </div>
            )}
            <Button type="primary" onClick={handleGoHome}>
                Go to Home
            </Button>
        </div>
    );
};

export default PaySuccess;